import { api } from '../../api/api'

// ------------------------------------
// Action Types & Creators
// ------------------------------------

// ------------------------------------
// Action Handlers
// ------------------------------------

const ACTION_HANDLERS = {}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}

export default function featureToggles(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

// ------------------------------------
// Sagas
// ------------------------------------

// ------------------------------------
// APIs
// ------------------------------------

export const referralsStatus = locationId => {
  const blacklist = [18478]
  if (blacklist.includes(Number(locationId))) return
  else
    return api.get(
      `/api/v1/shareables/referrals-enabled?locationId=${locationId}`,
      null,
      { cache: true },
    )
}
